"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenStage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
let TokenStage = class TokenStage extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-surface variant="outlined" radius="large">
        <mm-scroll>
          <slot></slot>
        </mm-scroll>
      </mm-surface>
    `;
    }
};
TokenStage.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    mm-surface {
      --surface-padding: var(--space-8) var(--space-16);
    }

    mm-scroll {
      width: 100%;
    }
  `;
TokenStage = __decorate([
    (0, decorators_js_1.customElement)('mm-token-stage')
], TokenStage);
exports.TokenStage = TokenStage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4tc3RhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0b2tlbi1zdGFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpELCtCQUE0QjtBQUdyQixJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsZ0JBQVU7SUFleEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozs7OztLQU1WLENBQUE7SUFDSCxDQUFDOztBQXRCTSxpQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7R0FZbEIsQ0FBQTtBQWJVLFVBQVU7SUFEdEIsSUFBQSw2QkFBYSxFQUFDLGdCQUFnQixDQUFDO0dBQ25CLFVBQVUsQ0F3QnRCO0FBeEJZLGdDQUFVIn0=